<template>
  <div class="myCollection">
    <div class="personal-box comWidth">
      <CenterNav/>
      <div class="personal-right">
        <NavT :titleS="titleS"/>
        <div class="rightmain">
            <div class="right-shoucang">
              <ul>
                <li v-for="(item,index) in collectionList">
                  <a>
                    <img :src="item.goods_thumb_url" alt="極草·5X冬蟲夏草純粉片（經典含片）0.25克/片×60片/瓶">
                  </a>
                  <div class="word-mian">
                    <div class="option">
                      <a class="f6" @click="addShopCar(item)">加入購物車</a>
                      <a class="f6" @click="removeFavorites(item,index)">移除收藏夹</a>
                    </div>
                    <a>
                      <h5>{{item.goods_name}}</h5>
                      <p>
                        <span class="price">￥{{item.price}}元</span>
                        {{item.comment_num}}人評價
                      </p>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
  //nav
  import NavT from '@/pages/personalPage/NavT'
  //cNav
  import CenterNav from '@/pages/personalPage/CenterNav'
  //api
  import {myFavorites,collectionCancel} from '@/api/collection';
  //common.js
  import {setLocalStorage, getLocalStorage,ifSignIn} from '@/utils/common';
  import { getToken } from '@/utils/auts'

  export default {
    name: 'MyCollection',
    components:{
      NavT,
      CenterNav
    },
    data () {
      return {
        titleS:'我的收藏',
        //收藏列表
        collectionList:[],
        //收藏加入购物车数据
        goodsList :''

      }
    },
    methods:{
      /*获取收藏列表*/
      getFavoritesList(){
        myFavorites().then(res =>{
            this.collectionList = res.data.data;
        })
      },

      /*移除收藏夹*/
      removeFavorites(item,index){
        collectionCancel(item.id).then(res =>{
          this.$message.success('移除成功');
          this.getFavoritesList();
        })
      },

      /*加入购物车*/
      addShopCar(item){
        //判断是否登录
        ifSignIn(this, () =>{
          this.purchaseData('ShoppingCart',item)
        })
      },

      /*购物车数据*/
      purchaseData(path , item){
          var shopDataLists = [];
          this.goodsList = item;
          this.goodsList.num = 1;
         delete this.goodsList.comment_num;
         shopDataLists.push(this.goodsList);
          //取出购物车数据
          getLocalStorage('shopDataLists' ,  (res) => {
            shopDataLists = res;
            //如果有数据，判断是否重复加入购物车
            if(res){
              if(shopDataLists.some(this.shopData)){}
              else {
                shopDataLists.push(this.goodsList)
              }
            }
          });
          //数据存储
          setLocalStorage('shopDataLists' , shopDataLists);
          this.$router.push({name:path});
      },


      /*判断购物车数据是否相同*/
      shopData(shop){
        if(shop.id == this.goodsList.id){
          return  shop.num = parseFloat(this.goodsList.num)  +　parseFloat(shop.num);
        }else {
          return  false;
        }
      },
    },
    created(){
        this.getFavoritesList();
      window.scrollTo(0,0)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.myCollection{
  .right-shoucang{
    ul{
      margin-bottom: 30px;
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;
      li{
        width: 180px;
        border: 1px solid #eee;
        padding: 18px 12px;
        background-color: #fff;
        overflow: hidden;
        position: relative;
        transition: all 0.3s linear;
        &:hover div .option{
          display: flex;
         }
        a{
          color: #000;
          img{
            width: 154px;
            height: 154px;
            display: block;
          }
        }

        .word-mian{
          padding: 0;
          .option{
            position: absolute;
            left: 0;
            top: 130px;
            width: 100%;
            display: none;
            transition: all 0.3s linear;
            a{
              background-color: #e20d31;
              width: 50%;
              color: #fff;
              text-align: center;
              height: 24px;
              line-height: 24px;
            }
            a:last-child{
              background-color: #9f9f9f;
            }
          }
          h5{
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          p{
            color: #9f9f9f;
            font-size: 12px;
            .price{
              display: block;
              color: #ca0000;
              margin: 4% 0;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/personalPage/orderCenter/MyCollection.vue